import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';

const StackItem = ( { title, vendor, logo } ) => {
  return (
    <Card style={ { boxShadow: '1px 5px 5px #CCC' } }>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text>{vendor}</Card.Text>
      </Card.Body>
    </Card>
  )
}

const Stack = () => {
    return (
      <Container fluid className='p-0' style={ { height: 'calc(100vh - 95px)' } }>
        <Row className='tf-page-container' style={ { height: 'calc(100% - 30px)' } }>
          <Col>
            <Row className='pt-3'>
              <Col><StackItem title='CRM' vendor='Jungo' logo='' /></Col>
              <Col><StackItem title='POS' vendor='Blend' logo='' /></Col>
              <Col><StackItem title='LOS' vendor='Encompass' logo='' /></Col>
            </Row>
            <Row className='pt-3'>
              <Col><StackItem title='PPE' vendor='Optimal Blue' logo='' /></Col>
              <Col><StackItem title='Appraisal Mgmt' vendor='Reggora' logo='' /></Col>
              <Col><StackItem title='Partner Performance Data' vendor='MMI' logo='' /></Col>
            </Row>
            <Row className='pt-3'>
              <Col><StackItem title='Email Routing' vendor='Outlook Exchange' logo='' /></Col>
              <Col><StackItem title='Txt Routing' vendor='TextUs' logo='' /></Col>
              <Col><StackItem title='Task Routing' vendor='Trello' logo='' /></Col>
            </Row>
            <Row className='pt-3'>
              <Col><StackItem title='Virtual Meetings' vendor='Zoom' logo='' /></Col>
              <Col><StackItem title='Video Messaging' vendor='BombBomb' logo='' /></Col>
              <Col><StackItem title='Calendar Scheduling' vendor='Calend.ly' logo='' /></Col>
            </Row>
            <Row className='pt-3'>
              <Col><StackItem title='Scenario Presentations' vendor='Mortgage Coach' logo='' /></Col>
              <Col><StackItem title='Client Retention' vendor='Homebot' logo='' /></Col>
              <Col><StackItem title='Client Intelligence' vendor='Sales Boomerang' logo='' /></Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
}

export default Stack;